import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Dashboard from "@/pages/Dashboard";
import NewEnvelope from "@/pages/NewEnvelope";
import EnvelopeDetail from "@/pages/EnvelopeDetail";
import Sign from "@/pages/Sign";
import Login from "@/pages/Login";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready)
    return <div className="min-h-screen camino-dark flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/sign/:token" element={<Sign />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/new" element={<Protected><NewEnvelope /></Protected>} />
          <Route path="/envelope/:id" element={<Protected><EnvelopeDetail /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
        </Routes>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
